import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import {convertirFecha} from "../../Utils/index";
const CardContacto =
  ({
    contact,
    selectedContact,
    click,
    setClick
  }) => {

    const link = '/contacts/' + `${contact.id}`

    return (
      <StyledLink to={link} target="_blank" style={{
        backgroundColor: click === contact.id ? '#dddddd' : '#FFFFFF'
      }}
        onClick={() => setClick(contact.id)}
        key={contact.id}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: "50%"
        }} >
          <Text
            selectedContact={selectedContact}
            contact={contact}>
            {contact.name} {contact.lastname}
          </Text>
          <Text
            style={{
              fontSize: '10px',
            }}
            selectedContact={selectedContact}
            contact={contact}>
            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <> 
                {'Último contacto ' + convertirFecha(contact.Observaciones[contact.Observaciones.length - 1].updatedAt)}
                 </> : 'Sin contactar'
            }
          </Text>
        </div>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          width: "50%"
        }} >
          <Text1>
            <b>Última observación.</b>
          </Text1>
          <Text1>
            {
              contact.Observaciones && contact.Observaciones?.length > 0 ?
                <>
                  {contact.Observaciones[contact.Observaciones.length - 1].observacion}
                </> : 'Sin contactar'
            }
          </Text1>
        </div>
      </StyledLink>
    );
  };

export default CardContacto;

const StyledLink = styled(Link)`
  width: -webkit-fill-available;
  padding: 8px;
  display: flex;
  flex-direction: row;
  gap: 5px;
  height: auto;
  align-content: flex-start;
  justify-content: start;
  align-items: center;
  border-top: 1.5px solid #e1e3ea;
  box-shadow: rgba(0, 0, 0, 0.05) 0px 0px 0px 1px;
  cursor: pointer;
  background-color: 'transparent' ;
  transition: all 0.3s ease-in-out;
  outline: none;
  text-decoration: none;
  &:hover{
      box-shadow: rgba(60, 64, 67, 0.9) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 1px 3px 1px;
      opacity: 0.5;
      will-change: transform;
  }
`;

const Text = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: ${(prop) => prop.selectedContact?.id === prop.contact.id ? '#07082c' : '#07082c'}  ;
`;

const Text1 = styled.span`
  width: -webkit-fill-available;
  font-family: 'Montserrat', sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #07082c;
`;
